// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2zhvG","ranges":"BmiRanges_ranges__1o5sd"};